import { useTranslation } from "react-i18next"
import { Text, View } from "react-native"

import { ChartData } from 'chart.js';
import 'chart.js/auto';
import { Doughnut } from "react-chartjs-2";

import { ReactComponent as MoreImg } from '../../../img/ico-prefix-more-dashboard.svg';

import DashboardBox from "../../base/tamplate/DashboardBox"
import { FONT } from "../../../value/staticValues";

interface BoldDoughnutChartProps {
    navigate: Function;
    url?: string;
    title: string;
    data: number;
    total: number;
    percent?: number;
    chartData: ChartData<'doughnut'>;
}
export default function BoldDoughnutChart(props: BoldDoughnutChartProps) {
    const DoughnutChartOption = {
        cutout: '50%',
        plugins: {
            responsive: true,
            legend: {
                display: false
            },
            tooltip: {
                enabled: false
            }
        }
    }

    return (
        <DashboardBox style={{
            width: 330, height: 320,
            marginRight: 10,
        }}>
            <View style={{flexDirection: "row", alignItems: "center", height: 20}}>
                <Text style={{
                    fontFamily: FONT.MEDIUM,
                    fontSize: 14,
                    lineHeight: 13,
                    color: "#262626"
                }}>
                    {props.title}
                </Text>
                {props.url ?
                    <MoreImg 
                        style={{marginLeft: "auto", cursor: "pointer"}}
                        onClick={() => {props.navigate(`${props.url}`)}}
                    />
                :null }
            </View>
            <View style={{flexDirection: "row", alignItems: "flex-start", marginTop: 20}}>
                <Text style={{
                    fontFamily: FONT.BOLD,
                    fontSize: 32,
                    color: "#333333"
                }}>
                    {props.data}
                </Text>
                <Text style={{
                    marginLeft: 3, marginTop: 8,
                    fontFamily: FONT.REGULAR,
                    fontSize: 12,
                    color: "#8c8c8c"
                }}>
                    Available
                </Text>
            </View>
            <View style={{
                alignItems: "center", justifyContent: "center",
                marginLeft: 50,
            }}>
                <View style={{width: 150, height: 150,}}>
                    <Doughnut data={props.chartData} options={DoughnutChartOption}/>
                </View>
            </View>
            <View style={{marginTop: "auto"}}>
                <Text style={{
                    fontFamily: FONT.MEDIUM,
                    fontSize: 14,
                    lineHeight: 12,
                    color: "#0853fb" 
                }}>
                    {props.percent ? props.percent + "%" : props.data} Used
                </Text>
                <Text style={{
                    marginTop: 10,
                    fontFamily: FONT.REGULAR,
                    fontSize: 12,
                    color: "#8c8c8c",
                }}>
                    Total {props.total}
                </Text>
            </View>
        </DashboardBox>
    )
}